import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationSelectors, ParentNavigationItem } from '@next/core-lib/navigation';
import { AgrWrapperSiteSidenavModule } from '@next/core-lib/wrapper-site-sidenav';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ReportPrintComponent } from './shared/report-print/report-print.component';
import { ReportPrintService } from './shared/report-print/report-print.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [AsyncPipe, RouterOutlet, AgrWrapperSiteSidenavModule, ReportPrintComponent],
})
export class AppComponent {
  public navigationItems$: Observable<ParentNavigationItem[]> = this.store.select(
    NavigationSelectors.selectNavigationItems,
  );
  public readonly report$ = this.reportPrintService.report$;

  constructor(
    private readonly store: Store,
    private readonly reportPrintService: ReportPrintService,
  ) {}
}
